import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { ColumnChangeBO } from '../list/list.model';

@Injectable({
  providedIn: 'root'
})
export class EvvTimesheetService {

  constructor(private http: HttpClient, public errorService: ErrorService,
  ) {
  }


  GetMappedEmployees(params: URLSearchParams): Observable<any> {
    let url = "api/Employee/GetMappedEmployees?";
    return this.http.get<any>(url + params, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }


  savecolumwidth(list: ColumnChangeBO): Observable<any> {

    let url = "api/ColumnChange/Savewidth?";
    return this.http.post<number>(url, list, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getservicegroupLst(params: URLSearchParams): Observable<any> {
    let url = "api/EvvClient/getClientService?";
    return this.http.get<any>(url + params, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }


  //===============================get Employee===============================//
  getEmployee(params: URLSearchParams): Observable<[{ Key: number, Value: string }]> {
    let url = "api/Client/GetEmpListbyType?"
    return this.http.get<[{ Key: number, Value: string }]>(url + params, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  //===============================get service===============================//

  getservice(params: URLSearchParams): Observable<[{ Key: number, Value: string }]> {
    let url = "api/Timesheet/GetServicedropdownByAgencyService?";
    return this.http.get<[{ Key: number, Value: string }]>(url + params, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  //===============================Update EvvTimesheet===============================//
  update(data): Observable<any> {
    let url = "api/Visit/UpdateVisit";
    return this.http.post<any>(url, data, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  /////////////////////////////// Delete Evvtimesheet////////////////////////////////////////////////////////

  deleteTimesheetdata(value: any): Observable<any> {
    let url = "api/Visit/CancelVisit";
    return this.http.post(url, value, { observe: 'response', responseType: 'text', }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  /////////////////get sign /////////////////////
  getsignature(appendata: URLSearchParams): Observable<any> {

    let url = "api/EvvTimesheet/getsign?";
    return this.http.get<any>(url + appendata, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  deleteMultiTimesheetdata(value: any): Observable<any> {
    let url = "api/Visit/CancelMultipleVisit";
    return this.http.post(url, value, { observe: 'response', responseType: 'text' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  //==============================get employee permission==========================================//
  getpermission(paramsData: URLSearchParams): Observable<any> {
    let url = "api/FunctionPermission/getfunctionpermissionemployee?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }


}
